import { render, staticRenderFns } from "./EditDateDialog.vue?vue&type=template&id=1aabeedc&scoped=true&"
import script from "./EditDateDialog.vue?vue&type=script&lang=js&"
export * from "./EditDateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aabeedc",
  null
  
)

export default component.exports